import './transitionEffect.css'

export default function TransitionEffect({topOriented}) {

    if(topOriented){
        return (
            <div className="relative back-container-white">
                <svg class="wave mt-1px" viewBox="0 0 1440 100" preserveAspectRatio="none">
                    <path
                        d="M0,50 C240,100 480,0 720,30 960,60 1200,100 1440,50 L1440,0 L0,0 Z"
                        fill="var(--global-bgbase-color)"
                    ></path>
                </svg>
            </div>
        )
    } else {
        return (
            <div className="relative back-container-white">
                <svg class="wave mb-5px" viewBox="0 0 1440 100" preserveAspectRatio="none">
                    <path
                    d="M0,50 C240,0 480,100 720,70 960,40 1200,0 1440,50 L1440,100 L0,100 Z"
                    fill="var(--global-bgbase-color)"
                    />
                </svg>
            </div>
        )
    }

}